import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const CaseCard = ({ c, index = 0, compact = false }) => (
  <Link to={`/work/${c.slug}`} className="group block" data-testid={`case-card-${c.slug}`}>
    <div className="relative aspect-[4/3] overflow-hidden rounded-[1.5rem] bg-muted">
      <img src={c.image} alt={`${c.industry} project`} loading="lazy" width="1200" height="800"
        className="h-full w-full object-cover transition-transform duration-[1.2s] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-[1.06]" />
      <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent" />
      <span className="absolute left-4 top-4 rounded-full bg-canvas/95 px-3 py-1.5 text-xs font-semibold text-ink">{c.industry}</span>
      <span className="absolute right-4 top-4 grid h-11 w-11 place-items-center rounded-full bg-flame text-white opacity-0 transition-[opacity,transform] duration-500 group-hover:rotate-45 group-hover:opacity-100">
        <ArrowUpRight className="h-5 w-5" />
      </span>
      <div className="absolute bottom-4 left-4 right-4 flex gap-2">
        {(c.metrics || []).slice(0, 2).map(([n, l]) => (
          <span key={l} className="rounded-xl bg-white/95 px-3 py-2 text-ink">
            <span className="block font-display text-xl font-bold leading-none">{n}</span>
            <span className="text-[11px] font-medium text-ink/70">{l}</span>
          </span>
        ))}
      </div>
    </div>
    <div className="mt-5 flex items-baseline gap-4">
      <span className="font-display text-sm font-semibold text-flame">{String(index + 1).padStart(2, "0")}</span>
      <div>
        <h3 className="font-display text-2xl font-semibold tracking-tight text-ink">{c.client}</h3>
        {!compact && (
          <dl className="mt-4 grid gap-3 text-sm leading-relaxed text-ink/75">
            <div><dt className="font-semibold text-ink">Challenge</dt><dd>{c.challenge}</dd></div>
            <div><dt className="font-semibold text-ink">Approach</dt><dd>{c.approach}</dd></div>
            <div><dt className="font-semibold text-ink">Results</dt><dd>{c.results}</dd></div>
          </dl>
        )}
        {compact && <p className="mt-2 text-sm leading-relaxed text-ink/70">{c.results}</p>}
      </div>
    </div>
  </Link>
);
